import MuiAlert from '@mui/material/Alert';
import type { AlertProps, AlertColor } from '@mui/material/Alert';
import MuiSnackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import React, { forwardRef } from 'react';

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface Props {
  handleClose: (event: React.SyntheticEvent | Event, reason?: string) => void;
  isOpen: boolean;
  message: string | undefined;
  severity: AlertColor;
  optionalMessage?: string;
  iconUrl?: string;
  autoHideDuration?: number;
}

export const Snackbars = ({
  handleClose,
  isOpen,
  message,
  severity,
  optionalMessage,
  iconUrl,
  autoHideDuration,
}: Props) => {
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {isOpen && (
        <MuiSnackbar
          open={isOpen}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          autoHideDuration={autoHideDuration}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: '100%' }}
          >
            {message}
            <div className="flex">
              {iconUrl !== undefined && <img src={iconUrl} alt="icon" />}
              {optionalMessage !== undefined && (
                <div className="text-[200%]">{optionalMessage}</div>
              )}
            </div>
          </Alert>
        </MuiSnackbar>
      )}
    </Stack>
  );
};
